import React from "react";
import { includes, get } from "lodash";
import { Redirect, Route } from "react-router-dom";
import PropTypes from "prop-types";
import { ROUTE, AUTH } from "../../constants";
import { QueryUtil, EnvUtil } from "../../utils";
import { useAppUser } from "../../Context";

const AuthRoute = props => {
  const {
    type,
    location
  } = props;
  const user = useAppUser();
  const isAuthenticated = Boolean(user);
  const roles = get(user, "roles", []);
  const hasAccessToMyDPD = includes(roles, AUTH.ROLES.myDPD);

  if (type === "guest" && isAuthenticated && hasAccessToMyDPD && location?.pathname === ROUTE.LOGON_PAGE) {
    // don't allow visiting login page being already logged in
    // you can make additional redirection in child switch
    return /*#__PURE__*/React.createElement(Redirect, {
      to: "/"
    });
  } else if (type === "private" && !isAuthenticated) {
    return /*#__PURE__*/React.createElement(Redirect, {
      to: {
        pathname: ROUTE.LOGON_PAGE,
        search: QueryUtil.stringifyQuery({
          carrier: EnvUtil.getBusinessIdFromOrigin(window.location),
          returnUrl: window.location.pathname
        }, false)
      }
    });
  }

  return /*#__PURE__*/React.createElement(Route, props);
};

AuthRoute.propTypes = {
  isAuthUser: PropTypes.bool,
  type: PropTypes.string,
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
};
export default AuthRoute;